import setAgentPreferences from 'actions/agent_preferences/set_agent_preferences';

export default class MarkFeatureTipAsSeen {
  constructor(context) {
    this.context = context;
  }

  run({ feature }) {
    const agentPreferences = this.context.stores.agentPreferences.get();
    agentPreferences.markFeatureTipAsSeen(feature);
    setAgentPreferences(this.context, agentPreferences);
  }
}
